/**
 * Expo Ortho — quantity tier summary.
 * Keeps the "{{ units }} · {{ unit_price }} each · Total {{ total }}" line under the tier cards
 * in step with the quantity input and with variant changes (product.js re-renders the cards).
 * Numbers come from data attributes on [data-tier-summary]; strings are the locale templates
 * passed in the same way. Depends on theme.utils.formatMoney (global.js).
 */
(function () {
  'use strict';

  const theme = window.theme;

  function fill(template, values) {
    return (template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => (key in values ? values[key] : match));
  }

  function unitsText(summary, count) {
    const template = count === 1 ? summary.dataset.textUnitsOne : summary.dataset.textUnitsOther;
    return fill(template, { count });
  }

  /** Recomputes the summary inside `root` (a <product-info>) from the current quantity. */
  function update(root) {
    const summary = root.querySelector('[data-tier-summary]');
    if (!summary) return;

    const money = theme.utils.formatMoney;
    const quantityInput = root.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, Math.round(Number(quantityInput && quantityInput.value) || 1));

    const units = Number(summary.dataset.units) || 1;
    const unitPrice = Number(summary.dataset.unitPrice) || 0;
    const baseUnitPrice = Number(summary.dataset.baseUnitPrice) || 0;
    const price = Number(summary.dataset.price) || 0;

    const totalUnits = units * quantity;
    const total = price * quantity;
    const saved = (baseUnitPrice - unitPrice) * totalUnits;

    const text = summary.querySelector('[data-tier-summary-text]');
    if (text) {
      text.textContent = fill(summary.dataset.textSummary, {
        units: unitsText(summary, totalUnits),
        unit_price: money(unitPrice),
        total: money(total),
      });
    }

    const save = summary.querySelector('[data-tier-summary-save]');
    if (save) {
      save.hidden = saved <= 0;
      save.textContent = saved > 0 ? fill(summary.dataset.textSave, { amount: money(saved) }) : '';
    }
  }

  function onQuantityEvent(event) {
    if (!event.target.matches('input[name="quantity"]')) return;
    update(event.target.closest('product-info') || document);
  }

  document.addEventListener('input', onQuantityEvent);
  document.addEventListener('change', onQuantityEvent);

  document.addEventListener('variant:changed', (event) => {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    const info = document.querySelector(`product-info[data-section-id="${CSS.escape(sectionId)}"]`);
    if (info) update(info);
  });
})();
